import React, { useState, useContext } from "react";
import MainContext from "../../../../Context/MainContext/MainContext";
import MUITextField from "@mui/material/TextField";
import MUIGrid from "@mui/material/Grid2";
import MUIIconButton from "@mui/material/IconButton";
import MUIEditIcon from "@mui/icons-material/Edit";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import TileDashboard from "../../../Tile/TileDashboard";
import DialogSearchDashboard from "../../../Dialog/Search/DialogSearchDashboard";
import Card from "../../../Card";

export default function CardAdminRoleGeneral(props) {
  const mainContext = useContext(MainContext);
  const [dashboardDialogOpen, setDashboardDialogOpen] = useState(false);

  const handleEditDashboard = () => {
    setDashboardDialogOpen(true);
  };

  const handleClearDashboard = () => {
    props.onChange({ defaultDashboardId: null });
    setDashboardDialogOpen(false);
  };

  const dashboardIconButtons = [
    <MUIIconButton key="edit-dashboard" onClick={handleEditDashboard}>
      <MUIEditIcon />
    </MUIIconButton>,
  ];

  if (props.role?.defaultDashboardId) {
    dashboardIconButtons.push(
      <MUIIconButton key="clear-dashboard" onClick={handleClearDashboard}>
        <MUIDeleteIcon />
      </MUIIconButton>,
    );
  }

  const renderContent = () => (
    <MUIGrid container spacing={2}>
      <MUIGrid size={12}>
        <MUITextField
          value={props.role ? (props.role.name ?? "") : ""}
          autoFocus={true}
          size="small"
          label="Name"
          variant="standard"
          fullWidth={true}
          onBlur={(e) => props.onChange({ name: e.target.value.trim() })}
          onChange={(e) => props.onChange({ name: e.target.value })}
          required={true}
          error={props.validationIssues.name ? true : false}
          helperText={
            props.validationIssues.name ? props.validationIssues.name : ""
          }
          slotProps={{
            htmlInput: {
              maxLength: 255,
            },

            inputLabel: { shrink: true },
          }}
        />
      </MUIGrid>
      <MUIGrid
        size={{
          xs: 12,
          sm: 6,
          md: 4,
        }}
      >
        <MUITextField
          value={props.role ? (props.role.description ?? "") : ""}
          size="small"
          label="Description"
          variant="standard"
          fullWidth={true}
          multiline={true}
          minRows={2}
          maxRows={6}
          onBlur={(e) =>
            props.onChange({ description: (e.target.value || "").trim() })
          }
          onChange={(e) => props.onChange({ description: e.target.value })}
          slotProps={{
            htmlInput: {
              maxLength: 2000,
            },

            inputLabel: { shrink: true },
          }}
        />
      </MUIGrid>
      <MUIGrid
        size={{
          xs: 12,
          sm: 6,
          md: 4,
        }}
      >
        <TileDashboard
          dashboard={
            props.role?.defaultDashboardId
              ? mainContext.dashboardsIndexed[props.role.defaultDashboardId]
              : null
          }
          iconButtons={dashboardIconButtons}
          label="Default Dashboard"
        />
      </MUIGrid>
      <DialogSearchDashboard
        open={dashboardDialogOpen}
        onClose={() => setDashboardDialogOpen(false)}
        onSelect={(dashboard) => {
          props.onChange({ defaultDashboardId: dashboard.id });
          setDashboardDialogOpen(false);
        }}
      />
    </MUIGrid>
  );

  return <Card renderContent={renderContent} getTitle={() => "General"} />;
}
